export default "__VITE_ASSET__9KlOXRur__"